// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__1aL0i","label":"Section_label__1NQ15","contentWrap":"Section_contentWrap__3MitU","footer":"Section_footer__2uTau","footerInner":"Section_footerInner__1VbPI"};